import { useMemo } from 'react'
import { Label } from 'semantic-ui-react'

import { UserWithAdminInfo } from '../../../../reducers/admin/allUsersReducer'
import { selectPrimaryMembershipForUser } from '../../../../selectors/user.selectors'
import { useReselector } from '../../../../utils/sharedHooks'
import { User } from '../../../../reducers/auth/userReducer'
import { TaxFilingUser } from '../../../../features/Taxes/AnnualTaxes/annualTaxFilings.slice'

const UserStateLabel = ({
  user,
}: {
  user?: UserWithAdminInfo | User | TaxFilingUser
}) => {
  const membership = useReselector(selectPrimaryMembershipForUser, user?.id)

  const color = useMemo(() => {
    if (membership?.status === 'paid') {
      return 'green'
    } else if (membership?.status === 'cancelling') {
      return 'orange'
    } else if (membership?.status === 'canceled') {
      return 'red'
    } else if (membership?.status === 'trial') {
      return 'yellow'
    }
    return undefined
  }, [membership?.status])

  return (
    <Label color={color}>
      <b>Heard Membership Status: </b>
      {membership?.status === 'signingUp'
        ? 'Signing Up — User Has Not Paid'
        : membership?.status}{' '}
      {membership?.hasAnnualCommitment && '| User has annual commitment'}
    </Label>
  )
}

export default UserStateLabel
